/* Mensa giveaway popup + bar. No fake counters: the countdown uses the real end date from data-end. */
(function () {
  var root = document.getElementById('MensaGiveaway');
  var bar = document.getElementById('MensaGiveawayBar');
  if (!root || root.dataset.mgInit) return;
  root.dataset.mgInit = '1';

  var END = Date.parse(root.getAttribute('data-end'));
  var KEY_SESSION = 'mensaGiveaway2026.sessionShown'; // sessionStorage: auto-open once per browser session
  var KEY_ENTERED = 'mensaGiveaway2026.entered';
  var KEY_PENDING = 'mensaGiveaway2026.pending';
  var DELAY = 7000; // auto-open 7s after page load
  var AUTO_OPEN = false; // 2026-09-27 per owner: popup never opens on its own (no timer, no exit-intent). Bar 'Enter now' / #giveaway links still open it. Set true to restore.
  if (!END || Date.now() >= END) return; // giveaway over: show nothing

  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var form = $('#MensaGiveawayForm') || $('form');
  var input = $('#MensaGiveawayEmail');
  var err = $('[data-mg-error]');
  var lastFocus = null;
  var isOpen = false;
  var closeTimer = null;
  var CLOSE_DELAY = 2000; // X button hidden + unclickable for 2s, then fades in; Esc and backdrop work immediately

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function parts() {
    var ms = Math.max(0, END - Date.now());
    var s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60, ms: ms };
  }
  function tick() {
    var p = parts();
    if (p.ms <= 0) { if (bar) bar.hidden = true; close(); root.hidden = true; clearInterval(timer); return; }
    var short = p.d > 0 ? p.d + 'd ' + p.h + 'h' : (p.h > 0 ? p.h + 'h ' + p.m + 'm' : p.m + 'm ' + pad(p.s) + 's');
    document.querySelectorAll('[data-mg-short]').forEach(function (el) { el.textContent = short; });
    var map = { d: String(p.d), h: pad(p.h), m: pad(p.m), s: pad(p.s) };
    Object.keys(map).forEach(function (k) { var el = $('[data-mg-' + k + ']'); if (el) el.textContent = map[k]; });
  }

  function setState(name) {
    root.querySelectorAll('[data-mg-state]').forEach(function (el) { el.hidden = el.getAttribute('data-mg-state') !== name; });
  }
  function open(source) {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    setState(ls(KEY_ENTERED) ? 'done' : 'form');
    root.classList.remove('mg--close-ready');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { root.classList.add('mg--close-ready'); }, CLOSE_DELAY);
    root.hidden = false;
    document.body.classList.add('mg-lock');
    if (!ls(KEY_ENTERED)) protect();
    if (source !== 'manual') ss(KEY_SESSION, String(Date.now()));
    var card = $('.mg__card');
    var wide = window.matchMedia('(min-width: 750px)').matches;
    setTimeout(function () { (wide && input && !ls(KEY_ENTERED) ? input : card).focus({ preventScroll: true }); }, 50);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    clearTimeout(closeTimer);
    root.classList.remove('mg--close-ready');
    root.hidden = true;
    document.body.classList.remove('mg-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.MensaGiveaway = { open: function () { open('manual'); }, close: close };

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-mg-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mg-open], a[href="#giveaway"]');
    if (t) { e.preventDefault(); open('manual'); }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') { // keep focus inside the dialog
      var f = Array.prototype.filter.call(root.querySelectorAll('a[href],button,input:not([type=hidden])'), function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function showError(msg) { err.textContent = msg; err.hidden = false; }
  function success() {
    ls(KEY_ENTERED, String(Date.now())); ls(KEY_PENDING, null);
    setState('done');
    var c = $('.mg__card'); if (c) c.focus({ preventScroll: true });
    try { document.dispatchEvent(new CustomEvent('mensa:giveaway-entered')); } catch (e) {}
  }

  /* Entry submit, AJAX so shoppers stay in the popup.
     Shopify spam protection (Online Store > Preferences > hCaptcha on contact/newsletter forms) binds an
     invisible hCaptcha to this form: it stops the submit, fetches a token, adds h-captcha-response, then calls
     form.submit(). We point form.submit at ajaxSend BEFORE it binds, so the token rides along in our fetch
     and no /challenge page is needed. If Shopify still answers with /challenge, we fall back to the native
     form so the entry is never lost (the page returns with ?customer_posted=true and the popup confirms). */
  var btn = form ? form.querySelector('[type=submit]') : null;
  var sending = false, busyTimer = null, nudged = false, retried = false;
  function setBusy(on) {
    if (!btn) return;
    clearTimeout(busyTimer);
    btn.disabled = on; btn.textContent = on ? 'Entering\u2026' : 'Enter now';
    if (on) busyTimer = setTimeout(function () { if (!sending) setBusy(false); }, 12000); // e.g. shopper closed a visual check
  }
  function isBound() { return !!(form && form.getAttribute('data-hcaptcha-bound')); }
  function protect() { // Shopify binds hCaptcha lazily on focus; nudge it early. No-op when spam protection is off.
    if (nudged || !form || form.dataset.cptcha) return;
    nudged = true;
    try { form.dispatchEvent(new FocusEvent('focusin', { bubbles: true })); } catch (e) {}
  }
  function captchaActive() { return !!(form && (form.dataset.cptcha || isBound())); } // set by Shopify's captcha-bootstrap
  function body() {
    var b = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { b.append(k, v); }); // includes h-captcha-response when present
    b.set('form_type', 'customer');
    b.set('utf8', '\u2713');
    b.set('contact[email]', (input.value || '').trim());
    b.set('contact[tags]', (form.querySelector('[name="contact[tags]"]') || {}).value || 'newsletter,giveaway-iphone-2026');
    b.set('contact[accepts_marketing]', 'true');
    return b;
  }
  function nativeSubmit() { ls(KEY_PENDING, '1'); HTMLFormElement.prototype.submit.call(form); }
  function ajaxSend() {
    if (sending) return;
    sending = true; setBusy(true);
    fetch('/contact#contact_form', {
      method: 'POST', body: body(), credentials: 'same-origin',
      headers: { Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
    })
      .then(function (res) {
        if (/\/challenge/.test(res.url)) { // Shopify still wants a visible captcha
          try { document.dispatchEvent(new CustomEvent('mensa:giveaway-challenge')); } catch (e) {}
          nativeSubmit(); return null;
        }
        return res.text().then(function (html) {
          if (res.status === 400 && /captcha/i.test(html)) { // token missing/expired: retry once through Shopify's hCaptcha
            if (captchaActive() && !retried) { retried = true; setTimeout(function () { form.submit(); }, 0); return; }
            showError('Please try again in a moment.'); return;
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var srvErr = doc.querySelector('#MensaGiveawayForm [data-mg-server-error]');
          var ok = /customer_posted=true/.test(res.url) || doc.querySelector('#MensaGiveawayForm [data-mg-server-ok]');
          if (srvErr && !/taken|already/i.test(srvErr.textContent)) { ls(KEY_PENDING, null); showError('Sorry, that email could not be entered. Please check it and try again.'); return; }
          if (ok || srvErr || res.ok) success(); else showError('Something went wrong. Please try again.');
        });
      })
      .catch(function () { nativeSubmit(); })
      .finally(function () { sending = false; setBusy(false); });
  }
  if (form) {
    try { form.submit = ajaxSend; } catch (e) {} // Shopify's hCaptcha calls this after adding its token
    form.addEventListener('submit', function (e) { // registered before hCaptcha binds, so it runs first
      err.hidden = true;
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        e.preventDefault(); e.stopImmediatePropagation();
        showError('Please enter a valid email address.'); input.focus(); return;
      }
      ls(KEY_PENDING, '1'); setBusy(true);
      if (isBound()) return; // hCaptcha's own listener runs next: token, then form.submit() -> ajaxSend
      e.preventDefault(); e.stopImmediatePropagation();
      protect();
      if (!captchaActive()) { ajaxSend(); return; } // spam protection off: plain AJAX
      // hCaptcha still loading: wait briefly for it, then submit through it
      var waited = 0, iv = setInterval(function () {
        waited += 100;
        if (isBound()) { clearInterval(iv); form.submit(); }
        else if (waited >= 6000) { clearInterval(iv); ajaxSend(); }
      }, 100);
    });
  }

  // Start
  if (bar) bar.hidden = false;
  tick();
  var timer = setInterval(tick, 1000);

  var params = new URLSearchParams(location.search);
  if (params.get('customer_posted') === 'true' && ls(KEY_PENDING)) { ls(KEY_ENTERED, String(Date.now())); ls(KEY_PENDING, null); ss(KEY_SESSION, String(Date.now())); open('manual'); return; }
  if (location.hash === '#giveaway') { ss(KEY_SESSION, String(Date.now())); open('manual'); return; }
  // Once per browser session (every visit). People who already entered see the "You're entered" state (open() picks it).
  if (ss(KEY_SESSION)) return;
  if (!AUTO_OPEN) return; // auto-open OFF: skip the 7s timer + exit-intent below

  var fired = false;
  function autoOpen() { if (fired) return; fired = true; clearTimeout(auto); document.removeEventListener('mouseout', onOut); open('auto'); }
  function onOut(e) { if (e.clientY <= 0 && !e.relatedTarget) autoOpen(); }
  var auto = setTimeout(autoOpen, DELAY);
  if (window.matchMedia('(pointer: fine) and (min-width: 990px)').matches) document.addEventListener('mouseout', onOut);
})();
